import React from "react";
import NewsForm from "../../../component/news-form";
import {addNews, getNewsDetail, updateNews} from "../../../action/news_action";
import {message, Skeleton} from "antd";

class NewsDetail extends React.Component{

    static STATE_STRUCT = () => {
        return {
            uploadLoading: false,
            loading: false,
            formDefaultValue: null,
        }
    };

    state = NewsDetail.STATE_STRUCT();

    componentDidMount() {
        if (this.props.match.params.id){
            this._getData(this.props.match.params.id);
        }
    }

    _getData = (id) => {
        this.setState({loading: true});
        getNewsDetail(id, (res, msg) => {
            if (res){
                this.setState({formDefaultValue: res});
            }else{
                message.error(msg ? msg : "获取新闻详情失败");
                this.props.history.push("/news");
            }
        });
    };

    _createForm = () =>
        (<NewsForm defaultFormValue={this.state.formDefaultValue} onUpload={(values)=>{
            this.setState({uploadLoading: true});
            if(this.props.match.params.id){
                values.id = this.props.match.params.id;
                updateNews(values, (res, msg) => {
                    this.setState({uploadLoading: false});
                    if (res){
                        this.props.history.push("/news");
                    }else
                        message.error(msg ? msg : "更新新闻失败");
                })
            }else{
                addNews(values, (res, msg) => {
                    this.setState({uploadLoading: false});
                    if (res){
                        this.props.history.push("/news");
                    }else
                        message.error(msg ? msg : "添加新闻失败");
                });
            }
        }} loading={this.state.uploadLoading} />);

    render() {
        return (
            <Skeleton loading={this.props.loading}>
                <div>
                    <span style={{fontSize: 30, fontWeight: 500, color: "black", lineHeight: "70px"}}>
                        {
                            this.props.match.params.id ? '更新新闻' : '添加新闻'
                        }
                    </span>
                    {
                        this.props.match.params.id ? (this.state.formDefaultValue ? this._createForm() : <br/>) : this._createForm()
                    }
                </div>
            </Skeleton>
        );
    }
}

export default NewsDetail;
